export const overlay = {
	selector: {
		own: '.js-overlay',
	},
}
